// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"ad44a0678bfbab32c09d","303":"934cb87153b209e6ef07","495":"de025539a775a9963a24"}[chunkId] + ".js";
};